import { render, staticRenderFns } from "./Confirm_customer_detail.vue?vue&type=template&id=cae87162&scoped=true&"
import script from "./Confirm_customer_detail.vue?vue&type=script&lang=js&"
export * from "./Confirm_customer_detail.vue?vue&type=script&lang=js&"
import style0 from "./Confirm_customer_detail.vue?vue&type=style&index=0&id=cae87162&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae87162",
  null
  
)

export default component.exports